module.exports = __webpack_public_path__ + "static/przesuwna-1-1bc408b408c6d02fe1652b2824ccec7c.jpg";